import axios from 'axios';

import {ActionType} from '../actionTypes';

import envManager from '../../com/envManager/EnvManager';

import {Action as SpotsActions} from '../actions/spotsActions'
import {Action as FlyerDetailsActions} from '../actions/flyerDetailsActions'

import {Dispatch} from 'redux';
import {
    UserDto,
    ErrorDtoFactory,
    CreateSpotsRequestDto,
    UpdateSpotsRequestDto,
    DeleteSpotsRequestDto,
    FlyerPageSpotDto,
    PromoDto, PromoItemsDto, FlyerPageDto,
} from '../../dtos';
import {FlyerDetailsState} from "../reducers/flyerDetailsReducer";


export const createSpots = (dto: CreateSpotsRequestDto, callback: Function) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    //
    return async (dispatch: Dispatch<SpotsActions>) => {

        dispatch({
            type: ActionType.POST_FLYER_SPOTS_CREATE_START
        })

        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + userDto.token,
                }
            }

            let result = await axios.post(
                `${envManager.flyerEditorServerAddress}/api/flyerPageSpots/CreateSpots`,
                dto,
                config
            );
            let data = result.data.data

            let dtos: FlyerPageSpotDto[] = data;

            dispatch({type: ActionType.POST_FLYER_SPOTS_CREATE_SUCCESS, payload: dtos})
            dispatch({type: ActionType.POST_FLYER_SPOTS_CREATE_COMPLETED})

            callback(true)
        } catch (err) {
            dispatch({
                type: ActionType.POST_FLYER_SPOTS_CREATE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })

            callback(false)
        }
    }

}


export const updateSpots = (dto: UpdateSpotsRequestDto, callback?: Function) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    //
    return async (dispatch: Dispatch<SpotsActions>) => {

        dispatch({
            type: ActionType.POST_FLYER_SPOTS_UPDATE_START
        })

        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + userDto.token,
                }
            }

            let result = await axios.post(
                `${envManager.flyerEditorServerAddress}/api/flyerPageSpots/UpdateSpots`,
                dto,
                config
            );
            let data = result.data.data

            let dtos: FlyerPageSpotDto[] = data;

            dispatch({type: ActionType.POST_FLYER_SPOTS_UPDATE_SUCCESS, payload: dtos})
            dispatch({type: ActionType.POST_FLYER_SPOTS_UPDATE_COMPLETED})
            if (callback) {
                callback(true)
            }
        } catch (err) {
            dispatch({
                type: ActionType.POST_FLYER_SPOTS_UPDATE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
            if (callback) {
                callback(false)
            }
        }
    }

}


export const deleteSpots = (dto: DeleteSpotsRequestDto, callback?: Function) => {

    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    //
    return async (dispatch: Dispatch<SpotsActions>) => {

        dispatch({
            // type: ActionType.POST_FLYER_SPOTS_CREATE_START
            type: ActionType.POST_FLYER_SPOTS_DELETE_START

        })

        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + userDto.token,
                }
            }

            let result = await axios.post(
                `${envManager.flyerEditorServerAddress}/api/flyerPageSpots/DeleteSpots`,
                dto,
                config
            );
            let data = result.data.data

            let dtos: FlyerPageSpotDto[] = data;

            // dispatch({ type: ActionType.POST_FLYER_SPOTS_CREATE_SUCCESS, payload: dtos })
            // dispatch({ type: ActionType.POST_FLYER_SPOTS_CREATE_COMPLETED })
            dispatch({type: ActionType.POST_FLYER_SPOTS_DELETE_SUCCESS, payload: dtos});

            dispatch({type: ActionType.POST_FLYER_SPOTS_DELETE_COMPLETED})

            if (callback) {
                callback(true)
            }
        } catch (err) {
            dispatch({
                // type: ActionType.POST_FLYER_SPOTS_CREATE_ERROR,
                type: ActionType.POST_FLYER_SPOTS_DELETE_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
            if (callback) {
                callback(false)
            }
        }
    }

}

export const changeOrientationNumberingForFrames = (isHorizontal: boolean) => {
    return async (dispatch: Dispatch<SpotsActions>) => {
        dispatch({
            type: ActionType.CHANGE_ORIENTATION_NUMBERING_FOR_FRAMES,
            payload: isHorizontal,
        });
    };
}

export const toggleSelectAllMode = (isSelectAll: boolean) => {
    return async (dispatch: Dispatch<SpotsActions>) => {
        dispatch({
            type: ActionType.TOGGLE_SELECT_ALL_FRAMES,
            payload: isSelectAll,
        });
    };
}

export const changeQualificationStatusForFrame = (
    flyerFramesIds: number[],
    languageCultureCode: string,
    qualificationLevel: number,
    flyerState: FlyerDetailsState,
    pageDtoNumber: number,
    currentFramesForPage: FlyerPageSpotDto[] = []
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<SpotsActions | FlyerDetailsActions>
    ) => {
        dispatch({
            type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_START,
        });

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }

            const request = {
                'userId': userDto.userId,
                'spotIds': flyerFramesIds,
                'uiLanguageCultureCode': languageCultureCode,
                'qualificationLevel': qualificationLevel,
                'flyerId': flyerState.flyRecId
            };
            let url = `${envManager.flyerEditorServerAddress}/api/FlyerPageSpots/SetSpotsQualification`;
            let result = await axios.post(url, request, config);
            let data = result.data;
            const newState = {...flyerState}
            const framesFromResponse: FlyerPageSpotDto[] = data.data.frames;
            newState.flyerPages[pageDtoNumber].flyerPageSpots?.forEach((frame: FlyerPageSpotDto) => {
                const frameFromResponse = framesFromResponse.find((frameFromResponse: FlyerPageSpotDto) => frameFromResponse.fpsRecId === frame.fpsRecId);
                if(frameFromResponse){
                    frame.qualificationLevel = frameFromResponse.qualificationLevel;
                    frame.flyerPromos?.forEach((promo: PromoDto) => {
                        const promoFromFrameResponse = frameFromResponse.flyerPromos?.find((promoFromFrameResponse: PromoDto) => promoFromFrameResponse.flrRecId === promo.flrRecId);
                        promo.qualificationLevel = promoFromFrameResponse ? promoFromFrameResponse.qualificationLevel : promo.qualificationLevel;
                        promo.flyerPromoItems?.forEach((item: PromoItemsDto) => {
                            const itemFromPromoFromFrameResponse = promoFromFrameResponse?.flyerPromoItems?.find((itemFromPromoFromFrameResponse: PromoItemsDto) => itemFromPromoFromFrameResponse.fpiRecId === item.fpiRecId);
                            item.qualificationLevel = itemFromPromoFromFrameResponse ? itemFromPromoFromFrameResponse.qualificationLevel : item.qualificationLevel;
                        })
                    })
                }
            });
            dispatch({
                type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                payload: newState,
            });
            const newFramesForPage = currentFramesForPage?.map((frame: FlyerPageSpotDto) => {
                const frameFromResponse = framesFromResponse.find((frameFromResponse: FlyerPageSpotDto) => frameFromResponse.fpsRecId === frame.fpsRecId);
                return {
                    ...frame,
                    qualificationLevel: frameFromResponse ? frameFromResponse.qualificationLevel : frame.qualificationLevel
                }
            });
            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_SUCCESS,
                payload: {
                    frames: newFramesForPage,
                    warnings: data.data.warnings
                }
            });


            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_COMPLETE,
                payload: data
            })
        } catch (err) {
            dispatch({
                type: ActionType.CHANGE_QUALIFICATION_STATUS_FOR_FRAMES_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    };
};
